import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const accentColor = '#00ff41';

const galleryImageUrls = [
  "https://public.readdy.ai/ai/img_res/9f03b82dcef6454edd31241963a1ddba.jpg",
  "https://static.readdy.ai/image/792df796680eec38aa20c46d1adacb8b/58f7cd0ee17d1dfc178a77f5d98c8187.jpeg",
  "https://readdy.ai/api/search-image?query=energy%20drink%20beverage%20product%20commercial%20TVC%20exploding%20liquid%20splash%20neon%20green%20glow%20cyberpunk%20dark%20studio%20background%20dramatic%20cinematic%20advertising%20photography&width=800&height=500&seq=tvc03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=electric%20vehicle%20car%20product%20advertisement%20cinematic%20dramatic%20lighting%20futuristic%20neon%20green%20glow%20dark%20background%20high%20tech%20premium%20automotive%20commercial&width=800&height=500&seq=tvc04&orientation=landscape",
  "https://readdy.ai/api/search-image?query=high%20end%20watch%20luxury%20product%20commercial%20advertisement%20close%20up%20macro%20photography%20neon%20green%20reflection%20glowing%20dark%20minimalist%20background%20cinematic%20quality&width=800&height=500&seq=tvc05&orientation=landscape",
  "https://readdy.ai/api/search-image?query=food%20product%20commercial%20advertisement%20sushi%20platter%20gourmet%20close%20up%20cinematic%20neon%20green%20light%20dark%20background%20restaurant%20premium%20quality%20film%20advertising%20style&width=800&height=500&seq=tvc06&orientation=landscape",
];

const featureIcons = ['ri-flashlight-line', 'ri-palette-line', 'ri-sun-line', 'ri-time-line'];

export default function TVCPage() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleLang = () => {
    i18n.changeLanguage(i18n.language === 'zh' ? 'en' : 'zh');
  };

  const galleryKeys = ['tvc.gallery.img1', 'tvc.gallery.img2', 'tvc.gallery.img3', 'tvc.gallery.img4', 'tvc.gallery.img5', 'tvc.gallery.img6'];
  const featureKeys = [
    { titleKey: 'tvc.feature1.title', descKey: 'tvc.feature1.desc' },
    { titleKey: 'tvc.feature2.title', descKey: 'tvc.feature2.desc' },
    { titleKey: 'tvc.feature3.title', descKey: 'tvc.feature3.desc' },
    { titleKey: 'tvc.feature4.title', descKey: 'tvc.feature4.desc' },
  ];
  const stepKeys = [
    { num: '01', titleKey: 'tvc.step1.title', descKey: 'tvc.step1.desc' },
    { num: '02', titleKey: 'tvc.step2.title', descKey: 'tvc.step2.desc' },
    { num: '03', titleKey: 'tvc.step3.title', descKey: 'tvc.step3.desc' },
    { num: '04', titleKey: 'tvc.step4.title', descKey: 'tvc.step4.desc' },
  ];

  return (
    <div className="min-h-screen bg-[#050d05] text-white font-['Space_Grotesk']">
      {/* Top Nav */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#050d05]/90 backdrop-blur-md border-b border-[#00ff41]/20">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group cursor-pointer">
            <img
              src="https://static.readdy.ai/image/792df796680eec38aa20c46d1adacb8b/8a76a6dd2c1eb78247ce2c779019b5d9.png"
              alt="Pixel Monster Logo"
              className="w-10 h-10 object-contain"
            />
            <div className="flex flex-col">
              <span className="text-base font-bold text-white font-['Space_Grotesk']">像素怪兽</span>
              <span className="text-xs font-['JetBrains_Mono']" style={{ color: accentColor }}>PIXEL MONSTER</span>
            </div>
          </Link>
          <div className="flex items-center gap-4">
            <button
              onClick={toggleLang}
              className="px-3 py-1 text-xs font-['JetBrains_Mono'] border transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105"
              style={{ borderColor: accentColor, color: accentColor, background: `${accentColor}15` }}
            >
              {t('nav.langToggle')}
            </button>
            <Link
              to="/"
              className="flex items-center gap-2 text-sm font-['JetBrains_Mono'] text-gray-400 hover:text-[#00ff41] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i>
              {t('service.backHome')}
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div
          className="absolute inset-0 opacity-5"
          style={{ backgroundImage: `repeating-linear-gradient(0deg, ${accentColor} 0px, ${accentColor} 1px, transparent 1px, transparent 60px), repeating-linear-gradient(90deg, ${accentColor} 0px, ${accentColor} 1px, transparent 1px, transparent 60px)` }}
        />
        <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full blur-[180px] opacity-10" style={{ background: accentColor }} />
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="inline-flex items-center gap-2 px-4 py-2 border text-xs font-['JetBrains_Mono'] font-semibold mb-8"
            style={{ borderColor: accentColor, color: accentColor, background: `${accentColor}15` }}>
            <span className="w-2 h-2 rounded-full animate-pulse" style={{ background: accentColor }}></span>
            {t('tvc.badge')}
          </div>
          <h1 className="text-6xl md:text-8xl font-black mb-6 leading-none tracking-tight">
            <span className="text-white">{t('tvc.h1.line1')}</span>
            <br />
            <span style={{ color: accentColor }}>{t('tvc.h1.line2')}</span>
          </h1>
          <p className="text-xl text-gray-400 font-['JetBrains_Mono'] mb-4 max-w-2xl leading-relaxed">
            {t('tvc.tagline')}
          </p>
          <p className="text-base text-gray-300 max-w-2xl leading-relaxed mb-12">
            {t('tvc.intro')}
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {(['tvc.stat1', 'tvc.stat2', 'tvc.stat3', 'tvc.stat4'] as const).map((key, i) => (
              <div key={i} className="border border-gray-700/50 p-6" style={{
                clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px))'
              }}>
                <div className="text-3xl font-black mb-1" style={{ color: accentColor }}>{t(`${key}.num`)}</div>
                <div className="text-xs text-gray-400 font-['JetBrains_Mono']">{t(`${key}.label`)}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="py-20 bg-[#020a02]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-12">
            <div className="text-xs font-['JetBrains_Mono'] mb-3" style={{ color: accentColor }}>{t('tvc.gallery.tag')}</div>
            <h2 className="text-4xl font-bold text-white">{t('tvc.gallery.title')}</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {galleryImageUrls.map((url, i) => (
              <div key={i} className="group relative overflow-hidden cursor-pointer"
                style={{ clipPath: 'polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px))' }}
              >
                <div className="w-full h-56 overflow-hidden">
                  <img src={url} alt={t(galleryKeys[i])} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <p className="text-sm font-['JetBrains_Mono']" style={{ color: accentColor }}>{t(galleryKeys[i])}</p>
                </div>
                <div className="absolute top-3 right-3 w-6 h-6 border-t-2 border-r-2 opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ borderColor: accentColor }}></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <div className="text-xs font-['JetBrains_Mono'] mb-3" style={{ color: accentColor }}>{t('tvc.features.tag')}</div>
              <h2 className="text-4xl font-bold text-white mb-8">
                {t('tvc.features.title1')}<br />
                <span style={{ color: accentColor }}>{t('tvc.features.title2')}</span>
              </h2>
              <div className="space-y-5">
                {featureKeys.map((f, i) => (
                  <div key={i} className="flex gap-4 p-4 border border-gray-800 hover:border-[#00ff41]/40 transition-colors"
                    style={{ clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 8px 100%, 0 calc(100% - 8px))' }}>
                    <div className="w-10 h-10 flex items-center justify-center flex-shrink-0" style={{ background: `${accentColor}15` }}>
                      <i className={`${featureIcons[i]} text-xl`} style={{ color: accentColor }}></i>
                    </div>
                    <div>
                      <div className="text-sm font-bold text-white mb-1">{t(f.titleKey)}</div>
                      <div className="text-xs text-gray-400 leading-relaxed">{t(f.descKey)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <div className="absolute -inset-4 blur-2xl opacity-20 rounded-full" style={{ background: accentColor }}></div>
              <div className="relative w-full h-96 overflow-hidden"
                style={{ clipPath: 'polygon(0 0, calc(100% - 24px) 0, 100% 24px, 100% 100%, 24px 100%, 0 calc(100% - 24px))' }}>
                <img
                  src="https://static.readdy.ai/image/792df796680eec38aa20c46d1adacb8b/8dd72e7348d4b3863f3e07e9d594dca0.jpeg"
                  alt="Monster Studio"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0" style={{ background: `linear-gradient(135deg, ${accentColor}20, transparent)` }}></div>
              </div>
              <div className="absolute bottom-4 left-4 px-3 py-2 bg-black/80 border text-xs font-['JetBrains_Mono']"
                style={{ borderColor: accentColor, color: accentColor }}>
                {t('tvc.imgTag')}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-20 bg-[#020a02]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <div className="text-xs font-['JetBrains_Mono'] mb-3" style={{ color: accentColor }}>{t('tvc.process.tag')}</div>
            <h2 className="text-4xl font-bold text-white">{t('tvc.process.title')}</h2>
          </div>
          <div className="grid md:grid-cols-4 gap-6">
            {stepKeys.map((s, i) => (
              <div key={i} className="relative p-6 border border-gray-700/60 hover:border-[#00ff41]/60 transition-colors"
                style={{ clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px))' }}>
                <div className="text-5xl font-black mb-4 opacity-20" style={{ color: accentColor }}>{s.num}</div>
                <div className="text-base font-bold text-white mb-2">{t(s.titleKey)}</div>
                <div className="text-xs text-gray-400 leading-relaxed">{t(s.descKey)}</div>
                {i < stepKeys.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-3 z-10 w-6 h-[2px]" style={{ background: accentColor }}></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5" style={{ background: `radial-gradient(ellipse at center, ${accentColor}, transparent)` }}></div>
        <div className="relative max-w-3xl mx-auto px-6 text-center">
          <div className="text-xs font-['JetBrains_Mono'] mb-4" style={{ color: accentColor }}>{t('tvc.cta.tag')}</div>
          <h2 className="text-5xl font-black text-white mb-6">
            {t('tvc.cta.title1')}<br />
            <span style={{ color: accentColor }}>{t('tvc.cta.title2')}</span>
          </h2>
          <p className="text-gray-400 mb-10 font-['JetBrains_Mono'] text-sm">{t('tvc.cta.desc')}</p>
          <Link
            to="/"
            onClick={() => setTimeout(() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }), 300)}
            className="inline-flex items-center gap-3 px-10 py-4 font-bold text-black transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            style={{ background: accentColor, clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px))' }}
          >
            <i className="ri-send-plane-line"></i>
            {t('tvc.cta.btn')}
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="https://static.readdy.ai/image/792df796680eec38aa20c46d1adacb8b/8a76a6dd2c1eb78247ce2c779019b5d9.png" alt="Logo" className="w-7 h-7 object-contain" />
            <span className="text-xs font-['JetBrains_Mono'] text-gray-500">© 2026 PIXEL MONSTER · All Rights Reserved</span>
          </div>
          <Link to="/" className="text-xs font-['JetBrains_Mono'] text-gray-500 hover:text-[#00ff41] transition-colors cursor-pointer">{t('service.backHome')} →</Link>
        </div>
      </footer>
    </div>
  );
}
